import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const OPEN_CUSTOMER_JOTRS_MODAL = 'OPEN_CUSTOMER_JOTRS_MODAL';
export const CLOSE_CUSTOMER_JOTRS_MODAL = 'CLOSE_CUSTOMER_JOTRS_MODAL';
export const CHANGE_PRIMARY_JOTR_REQUEST = 'CHANGE_PRIMARY_JOTR_REQUEST';
export const CHANGE_PRIMARY_JOTR_SUCCESS = 'CHANGE_PRIMARY_JOTR_SUCCESS';
export const CHANGE_PRIMARY_JOTR_FAILURE = 'CHANGE_PRIMARY_JOTR_FAILURE';
export const CHANGE_WHD_JOTR_REQUEST = 'CHANGE_WHD_JOTR_REQUEST';
export const CHANGE_WHD_JOTR_SUCCESS = 'CHANGE_WHD_JOTR_SUCCESS';
export const CHANGE_WHD_JOTR_FAILURE = 'CHANGE_WHD_JOTR_FAILURE';

function open() {
  return {
    type: OPEN_CUSTOMER_JOTRS_MODAL,
  };
}

function close() {
  return {
    type: CLOSE_CUSTOMER_JOTRS_MODAL
  };
}

function requestPrimary() {
  return {
    type: CHANGE_PRIMARY_JOTR_REQUEST,
  };
}

function receivePrimary(data) {
  return {
    type: CHANGE_PRIMARY_JOTR_SUCCESS,
    jotrs: data
  };
}

function rejectPrimary() {
  return {
    type: CHANGE_PRIMARY_JOTR_FAILURE,
  };
}

function requestWhd() {
  return {
    type: CHANGE_WHD_JOTR_REQUEST,
  };
}

function receiveWhd(data) {
  return {
    type: CHANGE_WHD_JOTR_SUCCESS,
    jotrs: data
  };
}

function rejectWhd() {
  return {
    type: CHANGE_WHD_JOTR_FAILURE,
  };
}

export function openCustomerJotrsModal() {
  return (dispatch) => {
    dispatch(open());
  };
}

export function closeCustomerJotrsModal() {
  return (dispatch) => {
    dispatch(close());
  };
}

export function changePrimaryJotr(customerId, jotrId) {
  return (dispatch) => {
    dispatch(requestPrimary());

    const promise = () => ApiService
      .changePrimaryJotr(customerId, jotrId)
      .then((response) => {
        dispatch(receivePrimary(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectPrimary, true));
        }
      });
    return promise();
  };
}

export function changeWhdJotr(customerId, jotrId) {
  return (dispatch) => {
    dispatch(requestWhd());

    const promise = () => ApiService
      .changeWhdJotr(customerId, jotrId)
      .then((response) => {
        dispatch(receiveWhd(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectWhd, true));
        }
      });
    return promise();
  };
}
